var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, Stack } from "@mui/material";
import Typography from "@mui/material/Typography";
/**
 * Displays an item in the summary content of an accordion.
 * This component, and it's parent (Accordion_SummaryContent), have expectations for their layout.
 * This component assumes it displays a column with a header and a value.
 * If this is not what you are looking for, you may want to use the
 * Accordion_SummaryItem_ChildrenContent (below).
 * @param param0
 * @returns
 */
export const Accordion_SummaryItem = (_a) => {
    var { title, detail, alignItems = "flex-start", justifyContent = "flex-start", flexWrap = "nowrap", gridArea, textAlignment = "left", titleTypographyVariant = "h7", detailTypographyVariant = "body1" } = _a, rest = __rest(_a, ["title", "detail", "alignItems", "justifyContent", "flexWrap", "gridArea", "textAlignment", "titleTypographyVariant", "detailTypographyVariant"]);
    return (_jsxs(Stack, Object.assign({ sx: {
            alignItems: alignItems,
            justifyContent: justifyContent,
            gridArea: gridArea,
            flexWrap: flexWrap,
            flexGrow: 1,
        } }, rest, { children: [_jsx(Box, Object.assign({ sx: {
                    textAlign: textAlignment,
                    width: "100%",
                } }, { children: _jsx(Typography, Object.assign({ variant: titleTypographyVariant }, { children: title })) })), detail && (_jsx(Box, Object.assign({ sx: {
                    textAlign: textAlignment,
                    width: "100%",
                } }, { children: _jsx(Typography, Object.assign({ noWrap: true, variant: detailTypographyVariant }, { children: detail })) })))] })));
};
/**
 * A summary item without content, appropriate for passing children.
 * This is still expected to be placed in the app's standard accordion summary
 * component (Accordion_SummaryContent).
 * @param param0
 * @returns
 */
export const Accordion_SummaryItem_ChildrenContent = (_a) => {
    var { alignItems = "flex-start", justifyContent = "flex-start", flexWrap = "nowrap", gridArea, children } = _a, rest = __rest(_a, ["alignItems", "justifyContent", "flexWrap", "gridArea", "children"]);
    return (_jsx(Stack, Object.assign({ sx: {
            alignItems: alignItems,
            justifyContent: justifyContent,
            gridArea: gridArea,
            flexWrap: flexWrap,
            flexGrow: 1,
        } }, rest, { children: children })));
};
